<script>
    import f9passengerPickerAccordion from "./f9passengerPickerAccordion";
    import f9input2 from "./f9input2";


    export default {
        props: {
            label: String,
            value: Object,
            maxPassengers: {
                type: Number,
                default: 9
            }
        },
        data() {
            return {
                expanded: false,
                passengersObject: this.value,
                travelerText: ""
            };
        },
        methods: {
            emitInput() {
                this.$emit('input', this.passengersObject);
            },
            buildTravelerText(numberToAdd, passengerType) {
                switch(passengerType) {
                    case "Adults":
                        this.travelerText = numberToAdd > 0 ? 
                            "Added 1 adult, " + this.passengersObject.adults.length + " adults total." :
                            "Removed 1 adult, " + this.passengersObject.adults.length + " adults total.";
                        break;
                    case "Lap Infants":
                        this.travelerText = numberToAdd > 0 ? 
                            "Added 1 lap infant, " + this.passengersObject.infants.length + " lap infants total." :
                            "Removed 1 lap infant, " + this.passengersObject.infants.length + " lap infant total.";
                        break;
                    case "Children":
                        this.travelerText = numberToAdd > 0 ? 
                            "Added 1 child, " + this.passengersObject.children.length + " children total." :
                            "Removed 1 child, " + this.passengersObject.children.length + " children total.";
                        break;
                }
            },
            onRemove() {
                if (this.passengersObject.infants.length === this.passengersObject.adults.length) {
                    this.passengersObject.infants.pop();
                }
            },
            toggle(show) {
                this.expanded = typeof show === 'boolean' ? show : !this.expanded
            },
            open() {
                this.toggle(true);
            },
            close() {
                this.toggle(false);
            }
        },
        computed: {
            totalPassengers() {
                return this.passengersObject.adults.length 
                    + this.passengersObject.children.length;
            },
            canAddAnyPassenger() {
                return this.totalPassengers < this.maxPassengers;
            },
            canAddAdults() {
                return this.passengersObject.adults.length < this.maxPassengers && this.canAddAnyPassenger;
            },
            canAddLapInfants() {
                return this.passengersObject.infants.length < this.passengersObject.adults.length;
            },
            canAddChildren() {
                return this.canAddAnyPassenger;
            },
            travelerInputString() {
                var returnStr = "";
                var adultCount = this.passengersObject.adults.length;
                var infantCount = this.passengersObject.infants.length;
                var childCount = this.passengersObject.children.length;

                //adult
                returnStr += adultCount + (adultCount > 1 ? " Adults, " : " Adult, ");

                //infant
                if (infantCount > 0) {
                    returnStr += infantCount + (infantCount > 1 ? " Lap Infants, " : " Lap Infant, ");
                }

                //child
                if (childCount > 0) {
                    returnStr += childCount + (childCount > 1 ? " Children, " : " Child, ");
                }

                //remove ', ' from return string
                if (returnStr) {
                    returnStr = returnStr.slice(0, -2);
                }

                return returnStr;
            }
        },
        watch: {
            expanded(val) {
                if(val) {
                    const firstDropdown = this.$refs.dropdown.querySelector("select,[tabindex='0']");
                    if(firstDropdown) {
                        setTimeout(() => firstDropdown.focus(), 500);
                    }
                }
            }
        },
        components: {
            f9passengerPickerAccordion,
            f9input2
        }
    }
</script>

<template>
    <div class="passenger-picker-container">
        <f9input2 class="passenger-picker-input"
            :placeholder="travelerInputString" 
            :aria-expanded="expanded ? 'true' : 'false'"
            type="text"
            readonly
            @click.native="expanded = true"
            @keypress.enter.native="expanded = true"
        ></f9input2>
        <span class="select-arrow" :class="expanded ? 'flip180' : 'unflip180'"></span>
        <div ref="dropdown" class="dropdown" :class="{ hide: !expanded }">
            <f9passenger-picker-accordion 
                accordionLabel="Adults"
                :canAddPassengers="canAddAdults"
                v-model="passengersObject.adults"
                :minimumNumberOfPassengersByType="1"
                @input="emitInput"
                :buildTravelersText="buildTravelerText"
                :onRemove="onRemove"
            ></f9passenger-picker-accordion>
            <f9passenger-picker-accordion 
                accordionLabel="Lap Infants"
                accordionSubLabel="(Under 2)"
                :canAddPassengers="canAddLapInfants"
                v-model="passengersObject.infants"
                @input="emitInput"
                :buildTravelersText="buildTravelerText"
            ></f9passenger-picker-accordion>
            <f9passenger-picker-accordion 
                accordionLabel="Children"
                accordionSubLabel="(Under 15)"
                :canAddPassengers="canAddChildren"
                v-model="passengersObject.children"
                @input="emitInput"
                :buildTravelersText="buildTravelerText"
            ></f9passenger-picker-accordion>
        </div>
        <div 
            class="traveler-bkg" 
            :class="{ hide: !expanded }"
            @click.stop.prevent="expanded = false"
        ></div>
        <span id="traveler-text" aria-live="polite">{{ travelerText }}</span>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    @import "~less-mixins";

    .passenger-picker-container {
        width: 315px;
        max-width: 100%;
        line-height: normal;
        letter-spacing: normal;
        position: relative;
        margin-top: 0;

        .passenger-picker-input {
            font-family: 'Montserrat', sans-serif; //Font for the placeholder text
            cursor: pointer;
            margin-top: 7px;
            font-size: 16px;
        }

        .select-arrow {
            position: absolute;
            right: 0;
            top: 0;
            text-align: center;
            z-index: 1;
            line-height: 38px;
            pointer-events: none;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: transparent url(https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/down-arrow-gray.png) no-repeat center center;
            height: 40px;
            width: 40px;
        }

        .flip180 {
            .rotate(180deg);
            transition: transform 300ms ease-in-out;
        }

        .unflip180 {
            .rotate(360deg);
            transition: transform 300ms ease-in-out;
        }

        .dropdown {
            z-index: 111;
            position: absolute;
            width: 315px;
            max-width: 100%;
            border: 1px solid @frontier-gray-xxlighter;
        }

        .traveler-bkg {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 110;
        }

        .hide {
            display: none;
        }

        #traveler-text {
            border: 0;
            clip: rect(1px, 1px, 1px, 1px);
            height: 1px;
            margin: -1px;
            overflow: hidden;
            padding: 0;
            position: absolute;
            width: 1px;
        }
    }

    
body.user-is-tabbing {
    .passenger-picker-input:focus {
        border: 4px solid #aaa;
        box-sizing: content-box;
        padding: 0;
    }
}
</style>